/* eslint-disable */
import $ from 'jquery';
import 'url-search-params-polyfill';
import MortgageUtils from './utils';
import Mediator from '../../common/scripts/observer';
import RangeSlider from '../range-slider';
import {Utils} from '../../common/scripts/utils';

const mediator = new Mediator();
const U = new MortgageUtils();

/**
 * 🟠🟠🟠🔸ORANGE FLAG!🔸🟧🟧🟧
 * Функциональность была изменена специально под этот проект
 */
class Mortgage {
    /**
     * Метод инициализирует модуль
     * @param {Object} wrap - обертка модуля
     */
    init(wrap) {
        this._getElements(wrap);
        this._subscribes();
        this._initCalcSliders();
        this._updateBenefitIds();
        this._hideBenefitsCards();
        this._onBenefitToggleChange();
        this._checkEmptyResult();
        this._forceInitialSync();
    }

    /**
     * Принудительная синхронизация слайдеров при загрузке
     * @private
     */
    _forceInitialSync() {
        setTimeout(() => {
            const $firstPaySlider = this.$wrap.find('.range-slider.first-pay');

            // Синхронизируем данные слайдеров из sessionStorage
            this._syncStorageFromSliders();

            // Обновляем слайдер первоначального взноса с учётом сохранённого значения
            const storedFirstPay = U.accessStorage('first-pay[min]', null);
            const price = U.accessStorage('price[min]', null);

            if ($firstPaySlider.length && price) {
                const minFirstPay = parseInt(price / 100 * this.minPV);
                const maxFirstPay = parseInt(price / 100 * this.maxPV);

                let firstPay = storedFirstPay;
                firstPay = parseInt(price * 0.21); // 21% от цены

                if (firstPay < minFirstPay) firstPay = minFirstPay;
                if (firstPay > maxFirstPay) firstPay = maxFirstPay;

                // Сохраняем откорректированное значение в storage
                U.accessStorage('first-pay[min]', firstPay);

                const sliderInstance = this.$firstPayInput.find('.j-range-slider__base').data('ionRangeSlider');
                if (sliderInstance) {
                    sliderInstance.update({
                        min: minFirstPay,
                        max: maxFirstPay,
                        from: firstPay
                    });
                }

                this.$firstPayInput.find('.range-slider__input')[0].value = firstPay.toLocaleString('ru-Ru');
            }

            this.setCredit();
            this.update();
        }, 300);
    }

    /**
     * Синхронизирует sessionStorage с текущими значениями слайдеров
     * @private
     */
    _syncStorageFromSliders() {
        const $priceSlider = this.$wrap.find('.range-slider.price');
        const $termSlider = this.$wrap.find('.range-slider.term');
        const $firstPaySlider = this.$wrap.find('.range-slider.first-pay');

        if ($priceSlider.length) {
            const priceInstance = $priceSlider.data('ionRangeSlider');
            if (priceInstance) {
                const priceValue = priceInstance.result.from;
                U.accessStorage('price[min]', priceValue);
            }
        }

        if ($termSlider.length) {
            const termInstance = $termSlider.data('ionRangeSlider');
            if (termInstance) {
                const termValue = termInstance.result.from;
                U.accessStorage('limitation[min]', termValue);
            }
        }

        if ($firstPaySlider.length) {
            const firstPayInstance = $firstPaySlider.data('ionRangeSlider');
            if (firstPayInstance) {
                const firstPayValue = firstPayInstance.result.from;
                U.accessStorage('first-pay[min]', firstPayValue);
            }
        }
    }

    /**
     * Метод получает требуемые элементы
     * @param {Object} wrap - обертка модуля
     */
    _getElements(wrap) {
        this.$wrap = $(wrap);
        this.$sliders = this.$wrap.find('.j-range-slider');
        this.$allCards = this.$wrap.find('.j-mortgage-card');
        this.$mortgageSubsidyTypes = this.$wrap.find('.j-mortgage-subsidy-type');
        this.$firstPayInput = this.$wrap.find('.j-range-slider.first-pay')
        this.$creditPercent = this.$wrap.find('.j-mortgage-slider__percent');
        this.$emptyResult = this.$wrap.find('.j-mortgage-empty');
        this.activeClass = 'is-active';
        this.disabledClass = 'is-disabled';
        this.minPV = 0;
        this.maxPV = 90;
        this.benefitIds = new Set();
    }

    /**
     * Обновляет список benefitIds из DOM
     * @private
     */
    _updateBenefitIds() {
        const benefitsWrapper = document.querySelector('.mortgage__filter-benefits');
        if (benefitsWrapper) {
            this.benefitIds = new Set(
                Array.from(benefitsWrapper.querySelectorAll('[data-benefit-id]'), item => item.dataset.benefitId)
            );
        }
    }

    /**
     * Инициализация слайдеров ипотечного калькулятора
     * @private
     */
    _initCalcSliders() {
        const rangeSliderSelectors = Array.from(this.$sliders);

        if (rangeSliderSelectors.length) {
            rangeSliderSelectors.forEach((rangeSliderSelector, i) => {
                Mortgage.initSlider(rangeSliderSelector, i);
            });
        }
    }

    static initSlider(slider) {
        const rangeSlider = new RangeSlider();

        rangeSlider.init({wrapper: slider});
    };

    /**
     * Метод содержит в себе колбэки на событиях других модулей
     * @private
     */
    _subscribes() {
        mediator.subscribe('rangeSliderStart', (data, rangeSlider) => {
            data.$input = data.input.closest('.j-range-slider').find('.range-slider__input');
            data.$postfix = data.input.closest('.j-range-slider').find('.range-slider__input-label_right_side');
            data.$rangeSlider = rangeSlider;
            this.updateSlidersValues(data, null);
            this.manualInput(data, this);
            this.setCredit();
            this.update();
        });

        mediator.subscribe('rangeSliderChange', (data) => {
            this.updateSlidersValues(data, 'set');
            // TODO Если мы изменяем слайдер (цену, срок ипотеки), который не относятся к слайдеру первоначального взноса
            if (data.$input[0] !== this.$firstPayInput.find('.range-slider__input')[0]) {
                this.setFirstPay();
            }
            this.setCredit();
            this.update();
        });

        mediator.subscribe('rangeSliderFinish', () => {
            this.setCredit();
            this.setShareParam();
        });

        mediator.subscribe('tabChange', (data)=>{
            const minPv = parseFloat($(data).attr('data-min-pv')) ? parseFloat($(data).attr('data-min-pv')) : 0; // добавлено услвие, потому что может быть 0% первоначальный взнос
            const maxPv = parseFloat($(data).attr('data-max-pv'));
            if (!isNaN(maxPv)) this.minPV = minPv
            if (maxPv) this.maxPV = maxPv
            if (minPv || maxPv) {
                this.setFirstPay(true);
                this.setCredit();
                this.update()
            }
        })
    }

    /**
     * Обновление значений экземпляра слайдера и запись в хранилище сессии при необходимости
     * @param {Object} data - данные слайдеров
     * @param {String/Null} flag - флаг, показывающий, нужно ли записывать данные слайдеров в хранилище сессии
     */
    updateSlidersValues(data, flag = null) {
        this.updateData(data, flag); //todo проверить зис
        Mortgage.setInput(data.from, data);
        // this.setCredit(onStart);
    }

    /**
     * Считываем из хранилища или записываем в хранилище данные о текущем положении ползунков
     * @param {Object} data - все значения слайдера
     * @param {String} flag - флаг, указывающий, что данные нужно записать в хранилище
     */
    updateData(data, flag) {
        const key = U.getObjectData(data).key;
        const isDisabled = data.input[0].disabled;

        if (parseInt(Utils.getUrlParams(key)) && flag !== 'set' && !isDisabled) {
            data.from = parseInt(Utils.getUrlParams(key));
            U.accessStorage(key, data.from);
        } else if (U.isExist(U.accessStorage(key, null)) && flag !== 'set' && !isDisabled) {
            data.from = U.accessStorage(key, null);
        } else {
            data.from = parseInt(data.from);
            U.accessStorage(key, data.from);
        }
    }

    /**
     * Записываем в инпуты значения слайдеров.
     * Добавляем разрядные пробелы и постфикс для срока кредита
     * @param {Object} value - значение слайдера
     * @param {Object} data - параметры слайдера
     */
    static setInput(value, data) {
        data.$input[0].value = value.toLocaleString('ru-Ru');
    }

    /**
     * Выводим сумму и процент кредита
     * Если процент больше 100, выделяем его красным, а сумму кредита не выводим
     */
    setCredit() {
        const creditData = U.calcCredit();
        this.creditDataAmount = parseInt(creditData.amount.replace(/\s/g, '').replace('₽', ''));

        this.$creditPercent.text(creditData.percent);
        //this.$creditPercent.text(U.calcCredit().percent);

    }

    /**
     * Метод для непосредственного взаимодействия с инпутами (без использования слайдеров)
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     */
    manualInput(data, obj) {
        this.chooseInputInteraction(data, obj, 'focus');
        this.chooseInputInteraction(data, obj, 'blur');
        this.chooseInputInteraction(data, obj, 'keyup');
        this.chooseInputInteraction(data, obj, 'keydown');
    }

    /**
     * Определение поведения инпутов и слайдеров при взаимодействии с инпутами
     * @param {Object} data - все значения слайдера
     * @param {Object} obj - экземпляр HTB для текущего инпута
     * @param {String} interaction - тип взаимодействия с инпутом
     */
    chooseInputInteraction(data, obj, interaction) {
        let onlyNumbersRegexp = /[^0-9.]/g;
        const that = this;

        data.$input.on(interaction, function(e) {
            switch (interaction) {
                case 'focus':
                    U.use$Value(this, '');
                    break;
                case 'blur':
                    if (U.use$Value(this) === '') {
                        Mortgage.setInput(data.from, data);
                    } else {
                        U.checkInputedData(this, data, onlyNumbersRegexp);
                        that.updateSlidersValues(data, 'set');
                        that.setCredit(false)
                        data.$rangeSlider.slider.update();
                        that.update();
                    }
                    break;
                case 'keyup':
                    if (U.use$Value(this)) {
                        Mortgage.setInput(+(U.use$Value(this).replace(onlyNumbersRegexp, '')), data);
                    }
                    break;
                case 'keydown':
                    U.preventNaNSymbolsEnter(e);
                    U.onKeyDownEvent(e, data, obj, this, onlyNumbersRegexp);
                    break;
                default: console.error('Wrong type of interaction');
            }
        });
    }

    /**
     * Рассчитываем ежемесячный платёж по формуле:
     * @param {Number} rate - ставка
     * @param {Number} additionalCost - наценка банка
     * @return {Number} - ежемесячный платёж
     * A = K * S,
     * где A - ежемесячный аннуитетный платёж,
     * K - коэффициент аннуитета,
     * S - сумма кредита.
     * K = (i * (1 + n)^n) / (((1 + i)^n) - 1)
     * i - месячная процентная ставка по кредиту (годовая/12)
     * n - количество периодов, в течение которых выплачивается кредит
     */
    static calcMonthlyPay(rate, additionalCost) {
        const i = rate / 12 / 100;
        const n = U.accessStorage('limitation[min]') * 12;
        const kNumerator = i * Math.pow(1 + i, n);
        const kDenominator = Math.pow(1 + i, n) - 1;
        const _K = kNumerator / kDenominator;
        const _S = U.accessStorage('creditAmount') + additionalCost;
        const _A = _K * _S;

        return _A < 0 ? '—' : _A;
    }

     /**
     * Высчитываем и устанавливаем ежемесячный платёж каждому банку
     */
    setPaymentOnTable() {
         [this.$allCards].forEach((item) => {
             for (let i = 0; i < item.length; i++) {
                 const additionalCost = Mortgage.setAdditionalCost($(item[i]));
                 Mortgage.calcPaymentForBank($(item[i]), additionalCost);
                 Mortgage.setFirstPayResult($(item[i]));
                 Mortgage.setLimitation($(item[i]));

                 const $flatPriceNode = $(item).find('.j-mortgage-flat-price');
                 const price = U.accessStorage('price[min]');

                 if ($flatPriceNode && price) {
                     $flatPriceNode.text(price.toLocaleString('ru-Ru') + ' ₽');
                 }
             }
         });
    }

    static calcPaymentForBank(item, additionalCost) {
        let rate = +item.find('.j-mortgage-rate').attr('data-rate');

        let monthlyPayment = U.isExist(Mortgage.calcMonthlyPay(rate, additionalCost)) ?
            U.calc('monthlyPaymentPretty', Mortgage.calcMonthlyPay(rate, additionalCost), null) : '—';
        item.find('.j-mortgage-payment').text(monthlyPayment);
    }

    static setFirstPayResult(item) {
        let pay = +item.find('.j-mortgage-first-payment').attr('data-firstPayment');
        let price = U.accessStorage('price[min]', null);

        let firstPayment = U.calc('monthlyPaymentPretty', (price * pay / 100));
        item.find('.j-mortgage-first-payment-val').text(firstPayment);
    }

    static setAdditionalCost(item) {
        const valueNode = item.find('.j-mortgage-addition-cost');
        let additionalCostValue = valueNode.attr('data-additional-cost');
        let price = U.accessStorage('price[min]', null);
        let additionalCost;
        let additionalCostPretty;

        if (isNaN(+additionalCostValue)) {
            additionalCostPretty = additionalCostValue || 'нет удорожания';
        } else {
            additionalCost = (price * additionalCostValue) / 100
            // const fixedAdditionalCost = parseInt(additionalCost.toFixed());
            // additionalCostPretty = `+ ${fixedAdditionalCost.toLocaleString('ru-Ru')} ₽`;

            additionalCostPretty = additionalCostValue + '%';
        }

        valueNode.text(additionalCostPretty);

        return additionalCost || 0;
    }

    static setLimitation(item) {
        const valueNode = item.find('.j-mortgage-limitation[data-update-limitation]');
        const currentLimitation = U.accessStorage('limitation[min]', null);

        valueNode.text(currentLimitation);
    }

    /**
     * Передаём список банков на проверку соответствия условиям
     * @private
     */
    _disableItems() {
        [this.$allCards].forEach((item) =>  {
            for (let i = 0; i < item.length; i++) {
                this._setDisabled($(item[i]));
            }
        });
    }

    /**
     * Отключаем банк, если он не подходит по параметрам
     * @param {Object} item - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setDisabled(item) {
        let firstPaymentCell  = item.find('.j-mortgage-first-payment');
        let limitationCell    = item.find('.j-mortgage-limitation');
        let monthlyPayment    = item.find('.j-mortgage-payment');
        let firstPayment      = +firstPaymentCell.attr('data-firstPayment');
        let firstPaymentMax   = +firstPaymentCell.attr('data-firstPaymentMax');
        let limitation        = +limitationCell.attr('data-limitation');
        let limitationMin     = +limitationCell.attr('data-limitationMin');
        let creditSummMax     = +item.attr('data-creditAmountMax');
        let creditSummMin     = +item.attr('data-creditAmountMin');

        if (U.accessStorage('creditPercent') < firstPayment    ||
            U.accessStorage('creditPercent') > firstPaymentMax ||
            U.accessStorage('limitation[min]') > limitation    ||
            U.accessStorage('limitation[min]') < limitationMin ||
            U.accessStorage('creditAmount')  < creditSummMin   ||
            U.accessStorage('creditAmount')  > creditSummMax) {
            monthlyPayment.text('—');
            item.addClass(this.disabledClass);
        } else {
            if(!item.hasClass('is-benefit')) {
                item.removeClass(this.disabledClass);
            }
        }
    }

    /**
     * Скрывает группу без результатов
     * @private
     */
    _disableSubsidyGroup(group) {
        const isGroupNotEmpty = $(group).children(`.best-card`).not(`.${this.disabledClass}`).length;

        if (isGroupNotEmpty) {
            $(group).removeClass(this.disabledClass);
        } else {
            $(group).addClass(this.disabledClass);
        }
    }

    /**
     * Скрывает группу без результатов
     * @private
     */
    _findCheapestInSubsidyGroup(group) {
        let specialOrderCoefficient = 10000000;
        let cheapestBank = null;

        $(group).children().each((index, child) => {
            // $(child).removeClass(this.activeClass);
            //
            // if ($(child).hasClass(this.disabledClass)) {
            //     return;
            // }
            if ($(child).hasClass(this.disabledClass) && $(child).hasClass(this.activeClass)) {
                $(child).removeClass(this.activeClass);
            }

            const order = +$(child).css('order');

            if (order < specialOrderCoefficient && child.classList.contains('bast-card')) {
                cheapestBank = child;
                specialOrderCoefficient = order;
            }
        })

        $(cheapestBank).addClass(this.activeClass);
    }

    /**
     * Отображает лучшие предложения в группе субсидий.
     * Для каждой группы оставляет активной только карточку с минимальной ставкой и минимальным первоначальным взносом.
     * Также добавляет уникальные логотипы банков в блок .mortgage__card-bank-list.
     * @private
     * @param {Array|NodeList} group - список карточек группы субсидий
     */
    _showedMultipleInSubsidyGroup(group) {
        // Сначала оставляем весь существующий код, который выбирает активную карточку и собирает уникальные логотипы
        const groupedByTypeAndSubsidy = Array.from(group).reduce((acc, item) => {
            const typeId = item.dataset.typeId;
            const subsidyType = item.dataset.subsidyType;

            if (!typeId || !subsidyType) return acc;

            if (!acc[typeId]) acc[typeId] = {};
            if (!acc[typeId][subsidyType]) acc[typeId][subsidyType] = [];

            acc[typeId][subsidyType].push(item);
            return acc;
        }, {});

        Object.entries(groupedByTypeAndSubsidy).forEach(([typeId, subsidyGroups]) => {
            Object.entries(subsidyGroups).forEach(([subsidyType, items]) => {
                // Находим карточку с минимальными rate + firstpayment
                const bestItem = items.reduce((min, item) => {
                    const rate = parseFloat(item.querySelector('.j-mortgage-rate')?.dataset.rate) || 0;
                    const firstPayment = parseFloat(item.querySelector('.j-mortgage-first-payment')?.dataset.firstpayment) || 0;

                    const minRate = parseFloat(min.querySelector('.j-mortgage-rate')?.dataset.rate) || 0;
                    const minFirstPayment = parseFloat(min.querySelector('.j-mortgage-first-payment')?.dataset.firstpayment) || 0;

                    if (rate < minRate) return item;
                    if (rate === minRate && firstPayment < minFirstPayment) return item;
                    return min;
                });

                bestItem.classList.add('best-card');
                if (!this.benefitIds.has(typeId)) {
                    bestItem.classList.add('is-active');
                }

                // Логотипы банка
                const subsidyTitleBlock = bestItem.querySelector('.mortgage__card-bank-list');
                if (subsidyTitleBlock) {
                    // Создаем Set для уникальности по alt
                    const existingAlts = new Set(
                        Array.from(subsidyTitleBlock.querySelectorAll('.mortgage__card-bank-item'))
                            .map(img => img.alt)
                    );

                    // Получаем текущий процент
                    const storedPercent = sessionStorage.getItem('creditPercent');
                    const currentPercent = storedPercent !== null ? parseFloat(storedPercent) : 0;

                    items.forEach(card => {
                        const firstPayment = parseFloat(card.dataset.firstpayment) || 0;

                        if (currentPercent >= firstPayment) {
                            const logos = card.querySelectorAll('.mortgage__card-bank-item');
                            logos.forEach(logo => {
                                if (logo.alt && !existingAlts.has(logo.alt)) {
                                    const newLogo = logo.cloneNode(true);
                                    subsidyTitleBlock.appendChild(newLogo);
                                    existingAlts.add(logo.alt);
                                }
                            });
                        }
                    });
                }
            });
        });
    }

    /**
     * Выводит в консоль сумму кредита для каждой карточки best-card
     * @private
     */
    _checkLoanAmounts() {
        const cards = document.querySelectorAll('.mortgage__card:not(.is-disabled)');

        cards.forEach(card => {
            const amountText = card.querySelector('.j-mortgage-loan-amount')?.textContent;
            if (!amountText) return;

            const amount = Number(amountText.replace(/\s+/g, ''));
            if (Number.isNaN(amount)) return;

            if (this.creditDataAmount > amount) {
                card.classList.add('is-disabled');
            }
        });
    }

    /**
     * Скрывает карточки, соответствующие активным фильтрам по преимуществам.
     * Для каждой карточки с data-program-type совпадающим с data-benefit-id чекбокса убирает класс is-active.
     * @private
     */
    _hideBenefitsCards() {
        document.querySelectorAll('.mortgage__card.best-card').forEach(card => {
            const { benefitId } = card.dataset;
            if (this.benefitIds.has(benefitId)) {
                card.classList.remove('is-active');
                card.classList.add('is-benefit');
                card.classList.add('is-disabled');
            }
        });
    }

    /**
     * Отслеживает изменение состояния чекбоксов преимуществ.
     * При изменении состояния чекбокса добавляет или убирает класс is-active у соответствующих карточек.
     * @private
     */
    _onBenefitToggleChange() {
        const benefitsWrapper = document.querySelector('.mortgage__filter-benefits');
        if (!benefitsWrapper) {
            return;
        }

        const applyBenefitFilter = (benefitId, checked) => {
            const cards = document.querySelectorAll(
                `.mortgage__card.best-card[data-benefit-id="${benefitId}"]`
            );

            cards.forEach(card => {
                card.classList.toggle('is-active', checked);
                card.classList.toggle('is-benefit', !checked);
                card.classList.add('is-disabled');
            });
        };

        const initCheckedBenefits = () => {
            const checkedBoxes = benefitsWrapper.querySelectorAll('.mortgage__toggle-input:checked');
            checkedBoxes.forEach(box => {
                applyBenefitFilter(box.dataset.benefitId, true);
            });

            if (checkedBoxes.length) {
                this.update();
            }
        };

        const onChange = (e) => {
            const box = e.target.closest('.mortgage__toggle-input');
            if (!box) {
                return;
            }

            applyBenefitFilter(box.dataset.benefitId, box.checked);
            this.update();
        };

        initCheckedBenefits();
        benefitsWrapper.addEventListener('change', onChange);
    }

    /**
     * Управляет отображением логотипов банков в активных карточках.
     * Если логотипов > 5 — скрывает остальные и активирует кнопку.
     * По клику на кнопку — показывает/скрывает лишние логотипы.
     * @private
     */
    _manageBankLogos() {
        const activeCards = document.querySelectorAll('.mortgage__card.is-active');

        activeCards.forEach(card => {
            const bankList = card.querySelector('.mortgage__card-bank-list');
            const bankBtn = card.querySelector('.mortgage__card-bank-btn');
            const bankBtnNumber = bankBtn?.querySelector('.mortgage__card-bank-btn-number');
            const bankBtnClose = bankBtn?.querySelector('.mortgage__card-bank-btn-close-icon');
            const logos = bankList?.querySelectorAll('.mortgage__card-bank-item');

            if (!bankList || !bankBtn || !logos?.length) return;

            const maxVisible = 5;
            const hiddenLogos = Array.from(logos).slice(maxVisible);


            if (logos.length > maxVisible) {
                hiddenLogos.forEach(logo => logo.classList.add('is-hidden'));
                bankBtn.classList.add('is-active');
                bankBtnNumber.textContent = `${logos.length - maxVisible}+`;
                bankBtnNumber.classList.remove('is-hidden');
                bankBtnClose.classList.add('is-hidden');
            } else {
                bankBtn.classList.remove('is-active');
                bankBtnNumber.textContent = '';
                bankBtnNumber.classList.add('is-hidden');
                bankBtnClose.classList.add('is-hidden');
            }

            if (!bankBtn.dataset.listenerAdded) {
                bankBtn.addEventListener('click', () => {
                    const isExpanded = bankList.classList.toggle('is-expanded');
                    hiddenLogos.forEach(logo => logo.classList.toggle('is-hidden', !isExpanded));

                    if (isExpanded) {
                        bankBtnNumber.classList.add('is-hidden');
                        bankBtnClose.classList.remove('is-hidden');
                    } else {
                        bankBtnNumber.classList.remove('is-hidden');
                        bankBtnClose.classList.add('is-hidden');
                    }
                });

                bankBtn.dataset.listenerAdded = 'true';
            }
        });
    }

    /**
     * Выводит плашку об отсутствии результатов
     * NB! Очень специфичный код, не подходит для переноса на другие проекты
     * @private
     */
    _checkEmptyResult() {
        this.$emptyResult.each((id, item) => {
            const $emptyResult = $(item);
            const $resultsWrapper = $emptyResult.parent();

            const $allCards = $resultsWrapper.find('.j-mortgage-card.best-card');
            const totalCards = $allCards.length;

            const $disabledCards = $allCards.filter(`.${this.disabledClass}`);
            const disabledCardsCount = $disabledCards.length;

            // Показываем сообщение, если ВСЕ карточки disabled
            const showEmptyMessage = totalCards > 0 && disabledCardsCount === totalCards;

            if (showEmptyMessage) {
                $emptyResult.addClass(this.activeClass);
            } else {
                $emptyResult.removeClass(this.activeClass);
            }
        });
    }

    /**
     * Передаём строки таблицы с банками на упорядочивание
     */
    _setTableOrder() {
        for (let i = 0; i < this.$allCards.length; i++) {
            this._setItemOrder($(this.$allCards[i]));
        }
    }

    /**
     * Устанавливаем свойство order для каждого банка, чтобы упорядочить элементы по цене
     * @param {Object} obj - DOM элемент каждого банка (строка в таблице или карточка)
     * @private
     */
    _setItemOrder(obj) {
        const specialOrderCoefficient = 10000000;
        let payment = +obj.find('.j-mortgage-payment').text().replace(/[^0-9]/g, '');
        obj.attr('data-payment', (payment === 0) ? specialOrderCoefficient : payment);

        if (obj.attr('data-sort') && !obj.hasClass(this.disabledClass)) {
            payment = +obj.data('sort');
        }

        obj.css('order', (payment === 0) ? specialOrderCoefficient : payment);
    }

     /**
     * Алгоритм MergeSort. Почти во всех браузерах используется по умолчанию,
     * однако google chrome использует данный алгоритм исключительно когда элементов для сортировки меньше 10
     * если элементов больше, что chrome начинает использовать QuickSort.
     * QuickSort значительно быстрее, нежели MergeSort, однако, в отличие от MergeSort, является нестабильным
     * (Unstable Algorithm, сортировка происходит без сохранения индексации элементов).
     * Из-за отсутствия индексации элементы с одинаковыми значениями хаотично меняются местами при сортировке.
     * WARNING! Не отключайте MergeSort для гугла, пожалейте эпилептиков
     * @param {Array} rows - массив строк таблицы банков
     * @return {Array} - смерженный массив
     */
    mergeSort(rows) {
        if (rows.length <= 1) {
            return rows;
        }

        const middle = Math.floor(rows.length / 2);
        const left = rows.slice(0, middle);
        const right = rows.slice(middle, rows.length);

        return Mortgage.merge(this.mergeSort(left), this.mergeSort(right));
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort
     * @param {Array} left - массив для слияния
     * @param {Array} right - массив для слияния
     * @return {Array} - отсортированный массив
     */
    static merge(left, right) {
        let result = [];

        while (left.length && right.length) {
            if (Mortgage.mergeSortFunction(left[0], right[0]) < 1) {
                result.push(left.shift());
            } else {
                result.push(right.shift());
            }
        }

        while (left.length) {
            result.push(left.shift());
        }

        while (right.length) {
            result.push(right.shift());
        }

        return result;
    }

    /**
     * Вспомогательная функция для алгоритма MergeSort.
     * @param {Object} a - объект сортировки
     * @param {Object} b - объект сортировки
     * @return {Number} - число, знак которого определяет местоположение элемента при сортировке
     */
    static mergeSortFunction(a, b) {
        return +$(a).css('order') - (+$(b).css('order'));
    }

    /**
     * Функция обновления значений ипотечной таблицы, карточек и количества предложений
     */
    update() {
        this.setPaymentOnTable();
        this._disableItems();
        this._setTableOrder();
        this._checkLoanAmounts();

        [...this.$mortgageSubsidyTypes].forEach((group) => {
            this._disableSubsidyGroup(group);
            this._findCheapestInSubsidyGroup(group);
        })

        this._showedMultipleInSubsidyGroup([...this.$allCards]);

        this._checkEmptyResult();
        setTimeout(() => {
            this._manageBankLogos();
        }, 50);
    }

    setShareParam() {
        const query = new URLSearchParams();

        query.append('calcPriceMean', U.accessStorage('price[min]'));
        query.append('calcFirstPaymentPercent', U.accessStorage('first-pay[min]'));
        query.append('calcPeriodMean', U.accessStorage('limitation[min]'));

        window.history.pushState(null, null, `?${query.toString()}`);
    }

    /*
    * TODO Необходимо переделать
    * При изменении значения в слайдере, мы расчитываем ПВ
    * Обновляем ionRangeSlider и заменяем значение в .value
    */
    setFirstPay(setMinPv = false) {
        const price  = U.accessStorage('price[min]', null);
        let firstPay = U.accessStorage('first-pay[min]', null);

        if (price && firstPay) {
            const minFirstPay = parseInt(price / 100 * this.minPV);
            const maxFirstPay = parseInt(price / 100 * this.maxPV);

            if (firstPay < minFirstPay) U.accessStorage('first-pay[min]', minFirstPay);
            if (firstPay > maxFirstPay) U.accessStorage('first-pay[min]', maxFirstPay);
            if (setMinPv) U.accessStorage('first-pay[min]', minFirstPay);
            firstPay = U.accessStorage('first-pay[min]');

            if (this.$firstPayInput) {
                this.$firstPayInput
                    .find('.j-range-slider__base')
                    .data('ionRangeSlider')
                    .update({
                        max: maxFirstPay,
                        min: minFirstPay,
                        from: firstPay,
                    });

                this.$firstPayInput.find('.range-slider__input')[0].value = firstPay.toLocaleString('ru-Ru');
            }
        }
    }
}

export default Mortgage;
/* eslint-enable */
